import { render, staticRenderFns } from "./changeModal.vue?vue&type=template&id=2b9b399e&scoped=true&"
import script from "./changeModal.vue?vue&type=script&lang=js&"
export * from "./changeModal.vue?vue&type=script&lang=js&"
import style0 from "./changeModal.vue?vue&type=style&index=0&id=2b9b399e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9b399e",
  null
  
)

export default component.exports